import { hasTokenProvider, setRefreshTokenTransport, setTokenProvider, type TokenProvider } from "@serophin/shared";
import type { ComponentChildren, ComponentType } from "preact";
import { hydrate, render } from "preact";
import { getAccessToken, hasRefreshSession } from "./auth-cache";
import { authTokenProvider } from "./auth-session";
import { ToastContainer } from "./components/ToastContainer";
import { applyTheme, watchSystemTheme } from "./theme";

export const SpaFrame = ({ children, toasts: Toasts = ToastContainer }: { children: ComponentChildren; toasts?: ComponentType | null }) => (
  <>
    {children}
    {Toasts && <Toasts />}
  </>
);

const installTokenProvider = (custom?: TokenProvider): TokenProvider | undefined => {
  const provider = custom ?? (hasTokenProvider() ? undefined : authTokenProvider);
  if (provider) {
    setTokenProvider(provider);
  }
  return provider;
};

export const initSpaApp = (config: { app: ComponentType; tokenProvider?: TokenProvider; hydrate?: boolean; toasts?: ComponentType | null }): void => {
  applyTheme();
  watchSystemTheme();
  setRefreshTokenTransport("cookie");

  const provider = installTokenProvider(config.tokenProvider);

  const App = config.app;
  const renderApp = () => {
    const appElement = document.getElementById("app");
    if (!appElement) {
      console.error("App element not found");
      return;
    }
    const tree = (
      <SpaFrame toasts={config.toasts}>
        <App />
      </SpaFrame>
    );
    if (config.hydrate) {
      hydrate(tree, appElement);
      return;
    }
    render(tree, appElement);
  };

  const start = () => {
    if (provider && !getAccessToken() && hasRefreshSession()) {
      provider.get().finally(renderApp);
      return;
    }
    renderApp();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
};
